<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
hr {
  border: none;
  height: 0.5px;
  /* Set the hr color */
  color: #ccc; /* old IE */
  background-color: #ccc; /* Modern Browsers */
}
</style>

<template>
  <div id="container">
      <div class="d-flex justify-content-between">
        <h4>Bit Utilization</h4>
        <div>
          <DxButton
            icon="download"
            hint="Download Bit excel file"
            :height="40"
            />
          <DxButton
            id="refreshButton"
            icon="revert"
            hint="Refresh"
            :height="40"
            @click="refreshGrids" />
        </div>
      </div>
    <br />
    <div>
      <h5 align="left">Bit Profile</h5>
      <DxDataGrid
        id="profile-grid"
        ref="bitProfileGrid"
        :data-source="bitProfileDataSource"
        :show-borders="false"
        :show-column-lines="false"
        :show-row-lines="true"
        column-resize-mode="nextColumn"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :cell-hint-enabled="true"
        :word-wrap-enabled="true"
        :column-auto-width="false"
        :height="400"
        date-serialization-format="yyyy-MM-dd"
        @row-inserted="onRowInserted"
        @row-updated="onRowUpdated"
        @row-removed="onRowRemoved"
        @saved="saved"
        @editing-start="onEditingStart"
      >
        <DxPaging :enabled="true" :page-size="5" />
        <DxEditing
          :allow-updating="editable"
          :allow-adding="editable"
          :allow-deleting="editable"
          :use-icons="true"
          mode="form"/>
        
        <DxColumn type="buttons" :width="120">
          <GridButton name="edit"/>
          <GridButton name="delete"/>
        </DxColumn>
        <DxColumn data-field="no" caption="Bit No"/>
        <DxColumn data-field="size" data-type="string" caption="Size">
          <DxLookup
            :data-source="optionSizes"
            value-expr="value"
            display-expr="text"/>
        </DxColumn>
        <DxColumn data-field="manufacturer" data-type="string" caption="Manufacturer"/>
        <DxColumn data-field="type" data-type="string" caption="Type" :calculate-display-value="setBitTypeDisplay">
          <DxLookup
            :data-source="optionBitType"
            value-expr="value"
            display-expr="text"/>
        </DxColumn>
        <DxColumn data-field="model" data-type="string" caption="Model"/>
        <DxColumn data-field="iadc" data-type="string" caption="IADC"/>
        <DxColumn data-field="serialNo" data-type="number" caption="SerialNo"/>
        <!-- DxColumn data-field="cost" data-type="number" caption="Bit Cost" format="currency"/ -->
        <DxColumn :visible="false" data-field="dateIn" data-type="date" caption="Date In"/>
        <DxColumn :visible="false" data-field="nozzleSize" caption="Nozzle Size"/>
        <DxColumn :visible="false" data-field="tfa" data-type="number" caption="TFA"/>
        <DxColumn :visible="false" data-field="operation" data-type="string" caption="Bit Operation">
          <DxLookup
            :data-source="optionBitOperation"
            value-expr="value"
            display-expr="text"/>
        </DxColumn>
        <DxColumn :visible="false" data-field="bhaType" data-type="string" caption="BHA Type">
          <DxFormItem :visible="false"/>
        </DxColumn>
        <DxColumn :visible="false" data-field="depthIn" data-type="number" caption="Depth In"/>
        <DxColumn :visible="false" data-field="depthOut" data-type="number" caption="Depth Out"/>
        <DxColumn :visible="false" data-field="cummHours" data-type="number" caption="Cumm.Hours"/>
        <DxColumn :visible="false" data-field="rollerConeDullGrade" data-type="string" caption="Roller Cone Dull Grade"/>
        <DxColumn :visible="false" data-field="pdcDullGrade" data-type="string" caption="PDC Dull Grade"/>
        <DxColumn :visible="false" data-field="cummkRevOB" data-type="number" caption="Cumm.kRevOn-Bottom"/>
        <DxColumn :visible="false" data-field="cummkRevTotal" data-type="number" caption="Cumm.kRevTotal"/>
        <DxColumn :visible="false" data-field="bitStatus" data-type="string" caption="Bit Status"/>
      </DxDataGrid>
      <br />
      <h5>Bit Operation</h5>
      <div style="height: 40px; display: flex; justify-content: right">
        <DxButton :visible="iconPhotoVisible" icon="image" hint="Photos" @click="onPhotoIconClick" />
      </div>
      <DxDataGrid
        ref="bitOp"
        :data-source="bitData"
        :show-borders="false"
        :show-column-lines="false"
        :show-row-lines="true"
        column-resize-mode="nextColumn"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :cell-hint-enabled="true"
        :word-wrap-enabled="false"
        :column-auto-width="false"
        :column-width="100"
        :height="400"
        key-expr="id"
        @row-click="onRowClick"
      >
        <DxPaging :enabled="true" :page-size="5" />
        <DxScrolling column-rendering-mode="virtual"/>
        <DxSelection mode="single"/>
        <DxColumn data-field="no" caption="Bit No"/>
        <DxColumn data-field="dateIn" data-type="date" caption="Date In"/>
        <DxColumn data-field="nozzleSize" caption="Nozzle Size"/>
        <DxColumn data-field="tfa" data-type="number" caption="TFA"/>
        <DxColumn data-field="operation" data-type="string" caption="Bit Operation" :calculate-display-value="setBitOperationDisplay"/>
        <DxColumn data-field="BHA Type" data-type="string" caption="BHA Type">
          <DxFormItem :visible="false"/>
        </DxColumn>
        <DxColumn data-field="depthIn" data-type="number" caption="DepthIn" />
        <DxColumn data-field="depthOut" data-type="number" caption="DepthOut" />
        <DxColumn caption="Cum. Footage" :calculate-display-value="setCumFootage" />
        <DxColumn data-field="cummHours" data-type="number" caption="Cumm.Hours" />
        <DxColumn caption="CPF" :calculate-display-value="setCPF" />
        <DxColumn caption="Avg WOB" :calculate-display-value="setAvgWOB" />
        <DxColumn caption="Avg Surface RPM" :calculate-display-value="setAvgRPM" />
        <DxColumn caption="AvgRPMM" :calculate-display-value="setAvgRPMM" />
        <DxColumn caption="Avg ROP" :calculate-display-value="setAvgROP" />
        <DxColumn caption="Avg Torque" :calculate-display-value="setAvgTorque" />
        <DxColumn caption="Avg Flowrate" :calculate-display-value="setAvgFlowrate" />
        <DxColumn caption="Avg Standpipe Pressure" :calculate-display-value="setAvgStandpipePressure" />
        <DxColumn data-field="rollerConeDullGrade" data-type="string" caption="Roller Cone Dull Grade"/>
        <DxColumn data-field="pdcDullGrade" data-type="string" caption="PDC Dull Grade"/>
        <DxColumn data-field="cummkRevOB" data-type="number" caption="Cumm.kRevOn-Bottom"/>
        <DxColumn data-field="cummkRevTotal" data-type="number" caption="Cumm.kRevTotal"/>
        <DxColumn data-field="bitStatus" data-type="string" caption="Bit Status"/>
      </DxDataGrid>
      <DxPopup
          :visible="popupVisible"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          :show-close-button="false"
          :show-title="true"
          :width="650"
          :height="700"
          container="#container"
          :title="popupTitle"
          @showing="loadBitPhotos"
        >
        <DxPosition
            at="bottom"
            my="center"
            of="positionOf"
            collision="fit"
          />
          <DxToolbarItem
            :visible="false"
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="addPhotoButtonOptions"
          />
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="closeButtonOptions"
          />
          <Gallery 
            :width="600" 
            :height="450" 
            :stretch-images="true" 
            :data-source="bitPhotos" 
            :loop="false" 
            :show-nav-buttons="true" 
            :show-indicator="true"/>
          <DxFileUploader
            ref="uploader"
            accept="image/*"
            :multiple="false"
            upload-mode="instantly"
            name="files"
            :upload-url="uploadPhotoUrl"
            :upload-custom-data="uploadPhotoData"
            :upload-headers="uploadHeaders"
            @value-changed="e => uploadFile = e.value"
            @files-uploaded="loadBitPhotos"
          />
          <DxLoadPanel :visible="photoIsLoading"/>
      </DxPopup>
    </div>
    <br />
  </div>
</template>

<script>
import Vue from 'vue'
import { formMethods, formComputed, authComputed } from '@state/helpers'
import { BootstrapVue, BootstrapVueIcons, BIconUpload } from 'bootstrap-vue'
import axios from 'axios'
import qs from 'querystring'
import mapApiUrl from '@/src/utils/api-mapper'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxSelection,
  DxLookup,
  DxScrolling,
  DxButton as GridButton
} from 'devextreme-vue/data-grid'
import { 
  DxPopup, 
  DxPosition, 
  DxToolbarItem 
} from 'devextreme-vue/popup'
import Gallery from 'devextreme-vue/gallery'
import notify from "devextreme/ui/notify"
import { DxLoadPanel } from 'devextreme-vue/load-panel'
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import DxButton from 'devextreme-vue/button'
import CustomStore from 'devextreme/data/custom_store'


Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.component('BIconUpload', BIconUpload)

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxFormItem,
    DxSelection,
    DxLookup,
    DxScrolling,
    GridButton,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    Gallery,
    DxLoadPanel,
    DxFileUploader,
    DxButton
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: 0,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    wellId: {
        type: Number,
        default: 0,
    }
  },
  data() {
    return {
      form: {},
      photoIsLoading: false,
      optionsComboHoleSize: [],
      // uploadPhotoUrl: "/api/master/bit/add-photo",
      uploadFile: null,
      files: [],
      casingSizes: ['4 1/2', '5', '5 1/2', '6 5/8', '7', '7 5/8', '7 3/4', '7 7/8', '8 5/8', '9 5/8', '9 7/8', '10 3/4', '11 3/4', '11 7/8', '12 1/4', '13 3/8', '13 1/2', '13 5/8', '14', '14 3/4', '16', '17 1/2', '18 5/8', '20', '22', '24', '26', '30', '32', '36', '40', '42'],
      optionSizes: [],
      fileUpload: '',
      popupVisible: false,
      popupTitle: 'Photos of',
      bitOperationSelected: undefined,
      idMap: [],
      optionBitType: [
        {text: "Roller Cone Insert", value: "RCI"},
        {text: "Roller Cone Milltooth", value: "RCM"},
        {text: "PDC", value: "PDC"},
        {text: "Hybrid", value: "Hybrid"}
      ],
      optionBitOperation: [
        {text: "Drill Formation", value: "DLFOR"},
        {text: "Drill Formation and Cement/Casing Accessories", value: "DLFORCECA"},
        {text: "Drill Cement", value: "DLCE"},
        {text: "Drill Casing Accessories", value: "DLCA"},
        {text: "Tagging", value: "TAG"},
        {text: "Clean Out", value: "CLOUT"},
        {text: "BHA Trip", value: "BHATRIP"},
        {text: "Reaming", value: "REAMING"},
        {text: "Push Liner", value: "PUSHLINER"},
        {text: "Push LCM", value: "PUSHLCM"},
        {text: "Wash", value: "WASH"}
      ],
      bitData: [
      ],
      title: [],
      bitPhotos: [],
      bitProfileDataSource: null,
      addPhotoButtonOptions: {
        text: 'Add',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: () => {
          this.upload()
        }
      },
      closeButtonOptions: {
        text: 'Close',
        stylingMode: 'outlined',
        type: 'danger',
        onClick: () => {
          this.popupVisible = false
        }
      },
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
    opopupTitle() {
      return "Photos of bit no. " + this.bitOperationSelected.no
    },
    uploadPhotoData() {
      return this.bitOperationSelected ? {bitId: this.bitOperationSelected.id} : null
    },
    bitProfileDatagrid() {
      return this.$refs.bitProfileGrid.instance
    },
    bitOpDatagrid() {
      return this.$refs.bitOp.instance
    },
    iconPhotoVisible() {
      return this.bitOperationSelected !== undefined
    },
    uploadHeaders() {
      return {Authorization: `Bearer ${this.currentUser.token}`}
    },
    uploadPhotoUrl() {
      return mapApiUrl("/api/form/master/bit/add-photo")
    }
  },
  watch: {
    submitId: function (value) {
      this.init()
    },
    wellId: function (newVal, oldVal) {
      // watch it
      this.init()
    },
  },
  created: function () {
    this.init()
    this.title = [[]]
    this.populateOptionSize()
    for (const entry in this.header) {
        this.title[0].push(entry.value)
    }
  },
  methods: {
    ...formMethods,
    init() {
      this.bitData = []
      this.bitProfileDataSource = new CustomStore({
        key: 'id',
        load: () => {
          const url = mapApiUrl('/api/form/master/bit/list/well')
          return axios.get(url, {params: {wellId: this.wellId}})
                      .then(response => response.data)
        },
        onLoaded: (result) => {
                this.idMap = []
                for (const row of result) {
                  this.idMap.push({id: row.id, submitId: row.submitId})
                } 
                this.bitData = Array.from(result)
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0]);
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          delete values.index
          delete values.from
          delete values.to
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/bit/add')
          return axios.post(url, qs.stringify(values)).then(response => response.data) 
        },
        update: (key, values) => {
          values.id = key
          const match = this.idMap.find(x => x.id === key)
          if (match === undefined) throw new Error("Update data corrupted")
          values.submitId =  match.submitId
          delete values.index
          delete values.from
          delete values.to
          const url = mapApiUrl('/api/form/master/bit/update')
          return axios.patch(url, values).then(response => response.data) 
        },
        remove: (key) => {
          const match = this.idMap.find(x => x.id === key)
          if (match === undefined) throw new Error("Data corrupted")
          const url = mapApiUrl('/api/form/master/bit/delete')
          return axios.delete(url + `?id=${key}&submitId=${match.submitId}`)
        },
      })
    },
    refreshGrids() {
      this.bitProfileDatagrid.refresh()
      // this.bitOpDatagrid.refresh()
    },
    onPhotoIconClick(e) {
      this.popupTitle = "Photos of bit no. " + this.bitOperationSelected.no
      this.popupVisible = true
      this.$refs.uploader.instance.reset()
    },
    upload() {
      axios.post(mapApiUrl("/api/form/master/bit/add-photo"),
        {params: { bitId: this.bitOperationSelected.id, files: this.uploadFile }})
        .then((response) => {
          console.log(response.data)
        })
    },
    setBitTypeDisplay(rowData) {
      const match = this.optionBitType.find(x => x.value === rowData.type)
      return match === undefined ? rowData.type : match.text
    },
    setBitOperationDisplay(rowData) {
      const match = this.optionBitOperation.find(x => x.value === rowData.operation)
      return match === undefined ? rowData.operation : match.text
    },
    photoPopupHiding() {
      this.popupVisible = false
    },
    cloneRow(e) {
      console.log(e)
    },
    setCumFootage(rowData) {
      return rowData.depthOut-rowData.depthIn
    },
    setCPF(rowData) {
      return "DATA"
    },
    setAvgWOB(rowData) {
      return "DATA"
    },
    setAvgRPM(rowData) {
      return "DATA"
    },
    setAvgRPMM(rowData) {
      return "DATA"
    },
    setAvgROP(rowData) {
      return "DATA"
    },
    setAvgTorque(rowData) {
      return "DATA"
    },
    setAvgFlowrate(rowData) {
      return "DATA"
    },
    setAvgStandpipePressure(rowData) {
      return "DATA"
    },

    populateOptionSize() {
      this.optionSizes = []
      for (const size of this.casingSizes) {
        this.optionSizes.push({value: size, text: size})
      }
    },

    onRowClick(e) {
      if (this.bitOperationSelected === undefined) {
        this.bitOperationSelected = e.data
        e.component.selectRows(e.data.id)
      }
      else {
        e.component.deselectAll()
        if (this.bitOperationSelected.id === e.data.id) {
          this.bitOperationSelected = undefined
        } else {
          this.bitOperationSelected = e.data
          e.component.selectRows(this.bitOperationSelected.id)
        }
      }
    },

    loadBitPhotos() {
      this.bitPhotos = []
      axios.get(mapApiUrl("/api/form/master/bit/get-photos"),
        {params: {bitId: this.bitOperationSelected.id}})
        .then((response) => {
          for (const photos of response.data) {
            this.bitPhotos.push(mapApiUrl("/api/form/master/bit/photos/" + photos.fileName))
          }
        })
    },
    onEditingStart(e) {
      this.currentlyEditable = this.editable && this.submitId === e.data.submitId
      e.cancel = false // !this.currentlyEditable
      if (e.cancel) {
        notify({ message: 'You can not change/remove other report.', width: 300 }, 'warning', 3000)
      }
    },
    onRowRemoved(e) {
      notify({ message: 'Bit data has been removed.', width: 500 }, 'success', 3000)
    },
    onRowInserted(e) {
      notify({ message: 'Bit data has been recorded.', width: 500 }, 'success', 3000)
    },
    onRowUpdated(e) {
      notify({ message: 'Bit data has been updated.', width: 500 }, 'success', 3000)
    },
    saved(e) {
    } 
  }
}
</script>